import React, { useLayoutEffect, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

import InquiryModal from '../InquiryModal';
import { fetchServices } from '../../utils/apiService';

// Default images for fallback if needed, though API should provide them
import img4 from '../../assets/image/img-4.jpg';

const Services = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedService, setSelectedService] = useState('');
    const [services, setServices] = useState([]);

    useLayoutEffect(() => {
        // Trigger animations for this section
        if (window.animationText) window.animationText();
        if (window.scrollingEffect) window.scrollingEffect();
        if (window.animateImgItem) window.animateImgItem();

        // Refresh ScrollTrigger as content might have changed
        if (window.ScrollTrigger) {
            window.ScrollTrigger.refresh();
        }
    }, [services]);

    useEffect(() => {
        const getServices = async () => {
            const result = await fetchServices();
            if (result && result.status && result.data) {
                setServices(result.data);
            }
        };
        getServices();
    }, []);

    const openModal = (service) => {
        setSelectedService(service);
        setIsModalOpen(true);
    };

    const getImageUrl = (imgVal) => {
        if (!imgVal) return img4; // Fallback
        const imgStr = imgVal.toString().trim();
        return imgStr.startsWith('http')
            ? imgStr
            : `${process.env.REACT_APP_STORAGE_BASE_URL || 'http://localhost:8000/storage'}/${imgStr}`;
    };

    return (
        <section className="section-services tf-spacing-2">
            <div className="mask mask-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="800" height="800" fill="none">
                    <circle cx="400" cy="400" r="325" stroke="url(#a3)" strokeWidth="150" />
                    <defs>
                        <linearGradient id="a3" x1="176" x2="569" y1="70.5" y2="674">
                            <stop offset="0" stopColor="#fff" stopOpacity="0.05" />
                            <stop offset="1" stopColor="#fff" stopOpacity="0" />
                        </linearGradient>
                    </defs>
                </svg>
            </div>
            <div className="section-top">
                <div className="tf-marquee">
                    <div className="marquee-wrapper">
                        <div className="initial-child-container">
                            {[...Array(20)].map((_, i) => (
                                <div className="big-text" key={i}>
                                    Explore <span className="text-stroke">Popular</span> Services
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <div className="tf-container">
                <div className="row">
                    <div className="col-12">
                        <div className="heading-section mb-60 text-center">
                            <div
                                className="sub-title body-2 fw-7 mb-17 title-animation"
                                dangerouslySetInnerHTML={{ __html: 'Our Popular Services' }}
                            />
                            <h2
                                className="title fw-6 title-animation"
                                dangerouslySetInnerHTML={{
                                    __html: `We Run All kinds Of IT Services <br /><span class="fw-3">We are deeply committed to the growth and success of our clients.</span>`
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <Swiper
                            modules={[Pagination]}
                            spaceBetween={0}
                            slidesPerView={1}
                            pagination={{ clickable: true, el: '.sw-pagination-services' }}
                            className="tf-swiper sw-services sw-border"
                            breakpoints={{
                                550: { slidesPerView: 2, slidesPerGroup: 1 },
                                1200: { slidesPerView: 3, slidesPerGroup: 1 }
                            }}
                        >
                            {services.map((item) => (
                                <SwiperSlide key={item.id}>
                                    <div className="services-item hover-image px-md-15 style-1">
                                        <div className="icon">
                                            <img src={getImageUrl(item.icon)} alt="icon" />
                                        </div>
                                        <h6 className="lh-30 fw-6"><Link to="/services" className="title-service"> {item.title}</Link></h6>
                                        <div className="desc lh-30">
                                            {item.description}
                                        </div>
                                        <Link to="/services" className="image">
                                            <img src={getImageUrl(item.image)} alt="Services" />
                                        </Link>
                                        <div className="bottom-item">
                                            <button
                                                className="tf-btn-readmore"
                                                onClick={() => openModal(item.title)}
                                                style={{ border: 'none', background: 'none', padding: 0 }}
                                            >
                                                <span className="plus">+</span>
                                                <span className="text">Inquiry Now</span>
                                            </button>
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        <div className="sw-pagination-services sw-pagination d-xl-none mt-15 justify-content-center"></div>
                    </div>
                </div>
            </div>
            <InquiryModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                initialService={selectedService}
            />
        </section>
    );
};

export default Services;
